module.exports = __webpack_public_path__ + "img/sum-it-white-svg.89cba4f9.svg";